import { render, staticRenderFns } from "./BillOfLadingConfirmation.vue?vue&type=template&id=6952e273&scoped=true"
import script from "./BillOfLadingConfirmation.vue?vue&type=script&lang=js"
export * from "./BillOfLadingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./BillOfLadingConfirmation.vue?vue&type=style&index=0&id=6952e273&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6952e273",
  null
  
)

export default component.exports